import React from "react"
import PropTypes from "prop-types"
import { CSVLink } from "react-csv"
import c from "./Button.module.scss"
import cn from "classnames"

/**
- 
**/

export const Button = ({ wide, size, light, disabled, children, onClick, className, ...rest }) => {
  const sizes = {
    large: [c.large],
    normal: [c.normal],
    small: [c.small],
    tiny: [c.tiny],
  }

  const classes = cn(c.button, sizes[size], className, {
    [c.wide]: wide,
    [c.light]: light,
    [c.disabled]: disabled,
  })
  return (
    <div className={classes} onClick={disabled ? null : onClick} {...rest}>
      <span>{children}</span>
    </div>
  )
}

export const DownloadButton = ({ data, filename, headers, children, ...rest }) => (
  <Button {...rest}>
    <CSVLink data={data} filename={filename} headers={headers} target='_blank' className={c.downloadButton}>
      {children}
    </CSVLink>
  </Button>
)

Button.defaultProps = {
  size: "normal",
  wide: false,
  light: false,
  disabled: false,
}

Button.propTypes = {
  size: PropTypes.oneOf(["large", "normal", "small", "tiny"]),
  wide: PropTypes.bool,
  light: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
}

export default Button
